import { Flex } from '@chakra-ui/react';
import { STATIC_COHORTS } from 'Deer/constants/cohorts';
import { addYears, startOfDay } from 'date-fns';
import { useDispatch } from 'react-redux';
import { checkEnableCompanySupport } from 'utils/helpers/featureFlags';

import { past3Months } from 'constants/ProjectConstants';
import { DISCIPLINARY_ACTIONS_INTENT_ID_MAP } from 'constants/moduleIntentTypes';

import { DateRangeDropdown } from 'uiToolkitV1/DateRange/DateRangeDropdown';
import { MultiSelectWithCheckboxes } from 'uiToolkitV1/MultiSelectWithCheckboxes/MultiSelectWithCheckboxes';

import {
  setDisciplinaryActionSelectedCompanies,
  setDisciplinaryActionSelectedLocations,
  setSelectedAdminReportDateRange,
  useSelectDisciplinaryActionsAllCompanies,
  useSelectDisciplinaryActionsAllLocations,
  useSelectDisciplinaryActionsSelectedCompanies,
  useSelectDisciplinaryActionsSelectedIntent,
  useSelectDisciplinaryActionsSelectedLocations,
} from '../slice/DisciplinaryActionsIntentSlice';

export const DisciplinaryActionMetaFilter = ({ cohortId }: { cohortId: number }) => {
  const dispatch = useDispatch();
  const { id } = useSelectDisciplinaryActionsSelectedIntent() || {};

  const allCompanies = useSelectDisciplinaryActionsAllCompanies();
  const selectedCompanies = useSelectDisciplinaryActionsSelectedCompanies();
  const allLocations = useSelectDisciplinaryActionsAllLocations();
  const selectedLocations = useSelectDisciplinaryActionsSelectedLocations();

  if (STATIC_COHORTS.company.id !== cohortId) return null;

  const showCompanyFilter = checkEnableCompanySupport() && allCompanies.length > 1;
  const showLocationFilter = checkEnableCompanySupport() && allLocations.length > 1;
  const showTimelineDropdown = id === DISCIPLINARY_ACTIONS_INTENT_ID_MAP.ADMIN_REPORTS;

  return (
    <Flex gap="12px">
      {showTimelineDropdown && (
        <DateRangeDropdown
          // @ts-expect-error idk :(
          onSelect={(dateRange) => {
            dispatch(setSelectedAdminReportDateRange({ startDate: dateRange.startDate, endDate: dateRange.endDate }));
          }}
          minDate={new Date(2020, 5, 1, 0, 0, 0, 0)}
          maxDate={addYears(startOfDay(new Date()), 5)}
          initialDateRange={past3Months}
          showPredefinedRanges
          variant="chip"
        />
      )}
      {showCompanyFilter && (
        <MultiSelectWithCheckboxes
          options={allCompanies.map(({ companyName, id }) => ({ label: companyName, value: id }))}
          selectedOptions={selectedCompanies.map(({ companyName, id }) => ({
            label: companyName,
            value: id,
          }))}
          onChange={(selected) => {
            dispatch(
              setDisciplinaryActionSelectedCompanies(
                selected.map(({ label, value }) => ({ companyName: label, id: value }))
              )
            );
          }}
          placeholder="Select companies"
          label="Companies"
        />
      )}
      {showLocationFilter && (
        <MultiSelectWithCheckboxes
          options={allLocations.map((locationName) => ({ label: locationName, value: locationName }))}
          selectedOptions={selectedLocations.map((locationName) => ({
            label: locationName,
            value: locationName,
          }))}
          onChange={(selected) => {
            dispatch(setDisciplinaryActionSelectedLocations(selected.map(({ value }) => value)));
          }}
          placeholder="Select locations"
          label="Locations"
        />
      )}
    </Flex>
  );
};
